import { getShippingChargeAmount } from "./shippingUtils";

/* ─────────────────────────────────────────────────────────────
   Dynamic prices for customizable products (price-per-inch)
   Returns MRP and SP both GST-inclusive
───────────────────────────────────────────────────────────── */
export const getDynamicPrices = (selectedProduct, selectedInch, quantity) => {
    if (!selectedProduct) return { mrp: 0, sp: 0 };
    const pricePerInchMrp = parseFloat(selectedProduct.mrp) || 0;
    const pricePerInchSp  = parseFloat(selectedProduct.sellingPrice) || 0;
    const currentInch     = parseInt(selectedInch) || 6;
    return {
        mrp: Math.round(pricePerInchMrp * currentInch * quantity * 1.18),
        sp:  Math.round(pricePerInchSp  * currentInch * quantity * 1.18),
    };
};

/* ─────────────────────────────────────────────────────────────
   Product-only total (GST inclusive, NO shipping)
   Use this for displaying the product subtotal
───────────────────────────────────────────────────────────── */
export const calculateTotal = (selectedProduct, selectedInch, quantity) => {
    if (!selectedProduct) return 0;
    if (selectedProduct.type === "Customize") {
        const pricePerInch = selectedProduct.sellingPrice / 6;
        return Math.round(pricePerInch * parseInt(selectedInch) * quantity * 1.18);
    }
    return Math.round(selectedProduct.sellingPrice * quantity * 1.18);
};

/* ─────────────────────────────────────────────────────────────
   Grand total = product total (GST incl.) + shipping charge
   address — customer's full address string (pincode extracted from it)
───────────────────────────────────────────────────────────── */
export const getGrandTotal = (selectedProduct, selectedInch, quantity, address) => {
    const productTotal  = calculateTotal(selectedProduct, selectedInch, quantity);
    const shippingCharge = getShippingChargeAmount(address);
    return {
        productTotal,
        shippingCharge,
        grandTotal: productTotal + shippingCharge,
    };
};
